export enum UserAuthority {
  /** It is unknown what this permission does. */
  defaultRolesInteractions = 'default-roles-interactions',
  /** Admin, same as @see systemAdmin. */
  roleInteractions = 'ROLE_INTERACTIONS',
  /** Full access to all clients, designs, & branches. */
  systemAdmin = 'system_admin',
  /** It is unknown what this permission does. */
  systemDesigner = 'system_designer'
}
